import firebase from 'firebase'
import 'firebase/auth'

firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIRE_APIKEY,
    authDomain: process.env.REACT_APP_FIRE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIRE_PROJECTID
})

export const db = firebase.firestore()
export const fireAuth = firebase.auth()